import { useTranslation } from 'react-i18next';
import type { RetentionPolicy } from '../api/types';
import { Badge } from '../components/ui';

export function RetentionBadge({ policy }: { policy: RetentionPolicy }) {
  const { t } = useTranslation();
  const tone = policy === 'KEEP_ALL' ? 'info' : policy === 'KEEP_LATEST' ? 'warning' : 'accent';
  return <Badge tone={tone}>{t(`retention.${policy}`)}</Badge>;
}
